// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__IM7su","buttons":"styles_buttons__Ksem1","yes":"styles_yes__dKc2V","no":"styles_no__cBeF-"};